import { c as _c } from "react/compiler-runtime";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import type { CreateWaveOutcomeConfig } from "@/types/waves.types";
import CreateWaveOutcomesRowRepApprove from "./CreateWaveOutcomesRowRepApprove";
import CreateWaveOutcomesRowRepRank from "./CreateWaveOutcomesRowRepRank";
import type { JSX } from "react";
export default function CreateWaveOutcomesRowRep(t0) {
  const $ = _c(10);
  const {
    waveType,
    outcome,
    removeOutcome
  } = t0;
  let t1;
  if ($[0] !== outcome || $[1] !== removeOutcome) {
    t1 = <CreateWaveOutcomesRowRepApprove outcome={outcome} removeOutcome={removeOutcome} />;
    $[0] = outcome;
    $[1] = removeOutcome;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== outcome || $[4] !== removeOutcome) {
    t2 = <CreateWaveOutcomesRowRepRank outcome={outcome} removeOutcome={removeOutcome} />;
    $[3] = outcome;
    $[4] = removeOutcome;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2) {
    t4 = {
      [ApiWaveType.Approve]: t1,
      [ApiWaveType.Rank]: t2,
      [ApiWaveType.Chat]: t3
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const components = t4;
  return components[waveType];
}